import Swal from "./swal";

const asText = (message) =>
  typeof message === "string" ? message : String(message ?? "");

const show = (icon, fallbackTimer = 2500) => (message, options = {}) => {
  const autoClose = options?.autoClose;
  const timer =
    autoClose === false ? undefined : Number.isFinite(autoClose) ? autoClose : fallbackTimer;

  return Swal.fire({
    icon,
    text: asText(message),
    position: "center",
    showConfirmButton: false,
    timer,
    timerProgressBar: Boolean(timer),
  });
};

export const toast = {
  success: show("success", 2200),
  error: show("error", 3000),
  info: show("info", 2500),
  warning: show("warning", 2800),
  dismiss: () => Swal.close(),
};

export const ToastContainer = () => null;

